export const locale = {
  lang: 'en',
  data: {
  
      TITLE: 'Digital Order Book',
      SORT_INFO: 'The digital order book is a web application that allows manufacturer or dealers to accept and manage orders that placed via website without using mobile app. Online Order Management Customer Order Management On Single Click.'
    
  }
}
